export function projectDraftFromDetail(detail = {}) {
  return JSON.parse(JSON.stringify({ name: '', instructions: '', defaultModelRef: null,
    members: [], capabilityBindings: [], ...detail }))
}

export function projectModelVerificationRequired(draft, originalModelRef) {
  const selected = draft.defaultModelRef
  return !draft.projectGuid || !originalModelRef || !selected || selected.source !== originalModelRef.source
    || String(selected.modelGuid).toLowerCase() !== String(originalModelRef.modelGuid).toLowerCase()
}

// 前端只拦截明显缺失/过期的检测结果，最终资格和配置摘要仍由服务端判断。
export function assertProjectModelVerification(draft, originalModelRef, verification, now = Math.floor(Date.now() / 1000)) {
  if (!projectModelVerificationRequired(draft, originalModelRef)) return
  const selected = draft.defaultModelRef
  const expectedKey = selected ? `${selected.source}:${selected.modelGuid}` : ''
  if (!verification || verification.status !== 'passed' || verification.modelKey !== expectedKey
    || !Number.isFinite(Number(verification.expiresAt)) || Number(verification.expiresAt) <= now
    || !['text', 'toolCall', 'plan', 'roundtrip'].every(check => verification.checks?.[check] === true)) {
    throw new Error('请先验证所选模型的主管能力，检测结果有效期为5分钟')
  }
}

// 项目配置只提交选中的引用与职责；创建者、提示词版本和 Key 由 PHP 决定。
export function buildProjectPayload(draft) {
  const name = String(draft.name || '').trim()
  const instructions = String(draft.instructions || '').trim()
  if (!name || name.length > 80) throw new Error('请填写1至80字的项目名称')
  if (!instructions || instructions.length > 20000) throw new Error('请填写项目目标与背景')
  const model = draft.defaultModelRef
  if (!model || !['platform', 'personal'].includes(model.source) || !/^[a-f0-9]{32}$/i.test(model.modelGuid || '')) {
    throw new Error('请选择可用模型，个人模型需先测试并保存')
  }
  const seen = new Set()
  const members = (draft.members || []).map(member => {
    if (!['internalAgent', 'copywritingEmployee'].includes(member.sourceKind)) throw new Error('员工类型不支持加入项目')
    const key = `${member.sourceKind}:${member.sourceGuid}`
    if (seen.has(key)) throw new Error('同一员工不能重复加入')
    seen.add(key)
    const roleInProject = String(member.roleInProject || '').trim()
    if (!roleInProject || roleInProject.length > 2000) throw new Error('请填写每位员工在项目中的职责')
    return { sourceKind: member.sourceKind, sourceGuid: String(member.sourceGuid), roleInProject }
  })
  const payload = { name, instructions, defaultModelRef: { source: model.source, modelGuid: model.modelGuid },
    members, capabilityBindings: JSON.parse(JSON.stringify(draft.capabilityBindings || [])) }
  if (draft.projectGuid) {
    payload.projectGuid = draft.projectGuid
    payload.configVersion = draft.configVersion
  }
  return payload
}

// 发布前默认关闭；验收并部署服务后可在PC构建配置中显式启用，不影响旧入口。
export const projectTeamsFeatureEnabled = (mode, optIn) => mode !== 'production' || optIn === 'true'
export const projectTeamsEnabled = projectTeamsFeatureEnabled(process.env.NODE_ENV, process.env.VUE_APP_PROJECT_TEAMS_ENABLED)
  || process.env.VUE_APP_ENABLE_PROJECT_TEAMS === 'true'
